import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import LessonCompleteDialog from './LessonCompleteDialog';
import { LessonCompleteContainer, LessonCompleteStatus } from './LessonDetailTab.style';
import useCoordinatedNavigationBlocker from './hooks/useCoordinatedNavigationBlocker';

const LessonComplete = ({
  isCompletedLesson,
  updateSectionComplete,
  updateSectionUnComplete,
  payload,
  sectionId,
  onLessonChanged,
}) => {
  const history = useHistory();
  const { registerBlocker, unregisterBlocker, allowNavigation } =
    useCoordinatedNavigationBlocker();
  const [timeUp, setTimeUp] = useState(false);
  const [showPrompt, setShowPrompt] = useState(false);
  const [seconds, setSeconds] = useState(300);
  const newRouteRef = useRef(null);
  const isCompletingInBlock = useRef(false);

  const onUnComplete = () => {
    if (isCompletedLesson) {
      updateSectionUnComplete(sectionId, payload);
      onLessonChanged(payload.lesson, false);
    }
  };

  const onComplete = () => {
    if (!isCompletedLesson) {
      updateSectionComplete(sectionId, payload);
      onLessonChanged(payload.lesson, true);
    }
  };
  // Register with coordinated navigation blocker
  useEffect(() => {
    const blockerId = 'lesson-complete';

    registerBlocker({
      id: blockerId,
      priority: 2, // Lower priority than slide edit reminder
      shouldBlock: () => {
        return timeUp && !isCompletedLesson && !isCompletingInBlock.current;
      },
      onBlock: (location) => {
        newRouteRef.current = location.pathname;

        // Skip blocking for home page
        if (location.pathname === '/') {
          return { showModal: false };
        }

        isCompletingInBlock.current = true;
        onComplete();
        setShowPrompt(true);

        return { showModal: true };
      },
    });

    // Cleanup on unmount
    return () => {
      unregisterBlocker(blockerId);
    };
  }, [timeUp, isCompletedLesson, registerBlocker, unregisterBlocker, onComplete]);

  useEffect(() => {
    let interval = null;
    if (isCompletedLesson) {
      return;
    }
    if (seconds && !isCompletedLesson) {
      interval = setInterval(() => {
        setSeconds((preValSeconds) => preValSeconds - 1);
      }, 1000);
    } else if (seconds === 0) {
      clearInterval(interval);
      setTimeUp(true);
    }
    return () => clearInterval(interval);
  }, [seconds, isCompletedLesson]);

  // This cleanup is now handled by the coordinated blocker registration useEffect

  const toggleComplete = () => {
    if (!isCompletedLesson) {
      onComplete();
    } else {
      onUnComplete();
    }
  };

  const onCancel = () => {
    setShowPrompt(false);
    allowNavigation();
  };

  const handleConfirm = () => {
    setShowPrompt(false);
    onUnComplete();
    allowNavigation();
  };

  return (
    <>
      <LessonCompleteContainer onClick={toggleComplete}>
        I taught some of these lesson slides
        <LessonCompleteStatus isCompleted={isCompletedLesson} />
      </LessonCompleteContainer>
      <LessonCompleteDialog
        isOpen={showPrompt}
        onConfirm={handleConfirm}
        onClose={onCancel}
      />
    </>
  );
};

export default LessonComplete;
